export const CREATE_THERMAL_STABILITY_TEST_REQUEST = "CREATE_THERMAL_STABILITY_TEST_REQUEST";
export const CREATE_THERMAL_STABILITY_TEST_SUCCESS = "CREATE_THERMAL_STABILITY_TEST_SUCCESS";
export const CREATE_THERMAL_STABILITY_TEST_FAILURE = "CREATE_THERMAL_STABILITY_TEST_FAILURE";
 
export const GET_THERMAL_STABILITY_TEST_REQUEST = "GET_THERMAL_STABILITY_TEST_REQUEST";
export const GET_THERMAL_STABILITY_TEST_SUCCESS = "GET_THERMAL_STABILITY_TEST_SUCCESS";
export const GET_THERMAL_STABILITY_TEST_FAILURE = "GET_THERMAL_STABILITY_TEST_FAILURE";

 
export const EDIT_THERMAL_STABILITY_TEST_REQUEST = "EDIT_THERMAL_STABILITY_TEST_REQUEST";
export const EDIT_THERMAL_STABILITY_TEST_SUCCESS = "EDIT_THERMAL_STABILITY_TEST_SUCCESS";
export const EDIT_THERMAL_STABILITY_TEST_FAILURE = "EDIT_THERMAL_STABILITY_TEST_FAILURE";
 
export const DELETE_THERMAL_STABILITY_TEST_REQUEST = "DELETE_THERMAL_STABILITY_TEST_REQUEST";
export const DELETE_THERMAL_STABILITY_TEST_SUCCESS = "DELETE_THERMAL_STABILITY_TEST_SUCCESS";
export const DELETE_THERMAL_STABILITY_TEST_FAILURE = "DELETE_THERMAL_STABILITY_TEST_FAILURE";


export const UPLOADCSV_THERMAL_STABILITY_REQUEST = "UPLOADCSV_THERMAL_STABILITY_REQUEST";
export const UPLOADCSV_THERMAL_STABILITY_SUCCESS = "UPLOADCSV_THERMAL_STABILITY_SUCCESS";
export const UPLOADCSV_THERMAL_STABILITY_FAILURE = "UPLOADCSV_THERMAL_STABILITY_FAILURE";